// extracted by css-extract-rspack-plugin
export default {"loading":"LoadingPage__loading--P1L9Q"};